/*
  Initialize modals  
  */

export function initModals() {
    //modal fragenquartett
    if ($('a#modal-fragenquartett')) {
        const fq = $('a#modal-fragenquartett');
        fq.click(function (e) {
            e.preventDefault();
            if ($('.o-section_black_overlay-slider')) {
                $('.o-section_black_overlay-slider').fadeToggle();
                $('.m-slider_fragenquartett').slick('resize');
            }
        })
    }

    //modal bildfluss
    if ($('a#modal-bildfluss')) {
        const bf = $('a#modal-bildfluss');
        bf.click(function (e) {
            e.preventDefault();
            if ($('.o-section_black_overlay')) {
                $('.o-section_black_overlay').fadeToggle();
            }
        })
    }

    //modal moderationsprozess
    if ($('a#modal-moderationsprozess')) {
        const mp = $('a#modal-moderationsprozess');
        mp.click(function (e) {
            e.preventDefault();
            if ($('.o-section_white_overlay-slider')) {
                $('.o-section_white_overlay-slider').fadeToggle();
                $('.m-slider_moderationsprozess').slick('resize');
            }
        })
    }

    //close all modals
    if ($('a#close-modal')) {
        const cm = $('a#close-modal');
        cm.click(function (e) {
            e.preventDefault();
            cm.closest('section').fadeOut();
        })
    }
}
